import * as types from "./iframe.constant";

const defaultState = {
    link:null,
    backUrl:"/"
 };

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.IFRAME_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.IFRAME_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
